/* MYALEPH: hide AOV drawer View cart / Cart — Checkout only (Fanny yes via CoS) */
(function () {
  var STYLE_ID = 'myaleph-hide-aov-view-cart-style';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#aov-cart-drawer .AOV-CDMinimal__ViewCartButton,' +
      '#aov-cart-drawer button.AOV-CDMinimal__ViewCartButton,' +
      '#aov-cart-drawer [class*="ViewCartButton"]{' +
      'display:none!important;visibility:hidden!important;height:0!important;' +
      'max-height:0!important;margin:0!important;padding:0!important;border:none!important;' +
      'overflow:hidden!important;pointer-events:none!important;position:absolute!important;left:-9999px!important;' +
      '}';
    (document.head || document.documentElement).appendChild(s);
  }

  function isViewCartEl(el) {
    if (!el || el.nodeType !== 1) return false;
    var cls = (typeof el.className === 'string' ? el.className : (el.getAttribute('class') || ''));
    if (/CheckoutButton/i.test(cls)) return false;
    if (/ViewCartButton/i.test(cls)) return true;
    var tag = (el.tagName || '').toLowerCase();
    if (tag !== 'button' && tag !== 'a') return false;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    return /^cart$/i.test(text) || /^view cart$/i.test(text);
  }

  function hideViewCart() {
    ensureStyle();
    var root = document.getElementById('aov-cart-drawer');
    if (!root) return;
    var nodes = root.querySelectorAll('button, a, [class*="ViewCartButton"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isViewCartEl(el)) continue;
      try {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
        if (el.parentNode) el.parentNode.removeChild(el);
      } catch (e) {}
    }
  }

  ensureStyle();
  hideViewCart();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideViewCart);
  }
  if (window.MutationObserver) {
    new MutationObserver(hideViewCart).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }
  setInterval(hideViewCart, 800);
})();
